import {MappedImageUrls} from "../ShoppingPresentationValueObject";
import {Types} from "../../../../type/Types";
import {PlacePathFileValueObject} from "./PlacePathFileValueObject";

export type PlacePresentationValueObject = {
    placePathJointId: bigint
    userId: bigint
    placeAttractionId: bigint | null
    placeName: string | null
    placeImageUrl: string | null
    keyword: string | null
    attractionRank: number | null
    keywordRank: number | null
    format: string | null
    mappedImageUrls: Record<number, PlacePathFileValueObject | null>
    browser: string | null
    visibility: number
    title: string | null
    description: string | null
    pathType: number | null
    isParticipating: boolean
}

export namespace PlacePresentationValueObject {
    export function construct(o: any): PlacePresentationValueObject {
        return {
            placePathJointId: BigInt(o.placePathJointId),
            userId: BigInt(o.userId),
            placeAttractionId: Types.asNull(o.placeAttractionId, BigInt),
            placeName: Types.asNull(o.placeName, String),
            placeImageUrl: Types.asNull(o.placeImageUrl, String),
            keyword: Types.asNull(o.keyword, String),
            attractionRank: Types.asNull(o.attractionRank, Number),
            keywordRank: Types.asNull(o.keywordRank, Number),
            format: Types.asNull(o.format, String),
            mappedImageUrls: o.mappedImageUrls,
            browser: Types.asNull(o.browser, String),
            visibility: Number(o.visibility),
            title: Types.asNull(o.title, String),
            description: Types.asNull(o.description, String),
            pathType: Types.asNull(o.pathType, Number),
            isParticipating: Boolean(o.isParticipating),
        }
    }
}